import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import get from "lodash/get";
import { Subscription } from "./subscription";
import { SubscriptionTestimonial } from "./subscription-testimonial";
import { SubscriptionHelper } from "./subscription-helpers";
import { SubscriptionCollection } from "./subscription-collection";
import { SubscriptionBankDetails } from "./subscription-bank-details"
import { isDesktopSizeViewport } from "../../../utils";
import "./subscription-page.m.css";

export const SubscriptionPage = props => {
  const [deviceWidth, deviceWidthHandler] = useState("");
  useEffect(() => {
    deviceWidthHandler(!isDesktopSizeViewport() ? "full-width" : "");
  }, []);

  const image = get(props.config, ["publisher", "publisher", "image"], "");
  const text = get(props.config, ["publisher", "publisher", "text"], "");
  const secondText = get(props.config, ["publisher", "publisher", "secondText"], "");
  const textInRed = get(props.config, ["publisher", "publisher", "textInRed"], "");
  return (
    <div>
      <Subscription />
      <SubscriptionBankDetails />
      <SubscriptionTestimonial {...props} />
      <div styleName="content" className="full-width-with-padding">
        <div styleName="video" className={`${deviceWidth}`}>
          <iframe
            width="670"
            height="376"
            src={image}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div styleName="video-text">
          <p styleName="text-one">{text}</p>
          {textInRed && <p styleName="text-one red">{textInRed}</p>}
          {secondText && <p styleName="text-two"> {secondText}</p>}
        </div>
      </div>
      <SubscriptionHelper {...props} />
      <SubscriptionCollection {...props} />
    </div>
  );
};

SubscriptionPage.propTypes = {
  config: PropTypes.object
};
